import { render } from "./DarkModeToggle.vue?vue&type=template&id=6079c57e&scoped=true"
import script from "./DarkModeToggle.vue?vue&type=script&lang=js"
export * from "./DarkModeToggle.vue?vue&type=script&lang=js"

import "./DarkModeToggle.vue?vue&type=style&index=0&id=6079c57e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6079c57e"]])

export default __exports__